import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useTenant } from "@/lib/tenant";
import { PageHeader, Panel, SevBadge, Empty } from "@/components/Bits";

export default function Identity() {
  const { tenantId } = useTenant();
  const { data = [] } = useQuery({
    queryKey: ["identity", tenantId],
    queryFn: () => api.get(`/identity/${tenantId}`).then((r) => r.data),
    enabled: !!tenantId,
  });

  if (!tenantId) return <Empty msg="Select an MSP tenant" />;

  return (
    <>
      <PageHeader title="Identity" kicker="AD · Entra ID · Google Workspace" />
      <div className="p-6">
        <Panel>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left font-mono text-[10px] uppercase tracking-widest text-zinc-500 border-b hairline">
                  <th className="px-4 py-3">User</th>
                  <th className="px-3 py-3">Directory</th>
                  <th className="px-3 py-3">Signal</th>
                  <th className="px-3 py-3">Detail</th>
                  <th className="px-3 py-3">Time</th>
                  <th className="px-3 py-3">Severity</th>
                </tr>
              </thead>
              <tbody>
                {data.map((a) => (
                  <tr key={a.id} className="border-b hairline hover:bg-white/[0.03]">
                    <td className="px-4 py-2.5">
                      <div className="text-sm">{a.user}</div>
                      <div className="font-mono text-[10px] text-zinc-500">{a.email}</div>
                    </td>
                    <td className="px-3 py-2.5 text-zinc-300 text-xs">{a.directory}</td>
                    <td className="px-3 py-2.5 font-mono text-[10px] uppercase tracking-widest text-cyan-300">{a.kind}</td>
                    <td className="px-3 py-2.5 text-zinc-300 text-xs">{a.detail}</td>
                    <td className="px-3 py-2.5 font-mono text-[10px] text-zinc-500">{new Date(a.ts).toLocaleString()}</td>
                    <td className="px-3 py-2.5"><SevBadge sev={a.severity} /></td>
                  </tr>
                ))}
                {data.length === 0 && <tr><td colSpan={6}><Empty /></td></tr>}
              </tbody>
            </table>
          </div>
        </Panel>
      </div>
    </>
  );
}
